import { IApiResponse, IPreferredLanguage } from "../../Orchestrator/Types/Index";
import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";

export async function getPreferredLanguages(): Promise<
  IApiResponse<{ answer: IPreferredLanguage[] }>
> {
  const endpoints = await getEndpoints();
  const endpoint = endpoints.getLanguage;
  // Background metadata — never raise the blocking loader.
  return await apiRequest<{ answer: IPreferredLanguage[] }>(endpoint, "GET", {}, "none", undefined, undefined, false);
}
